<template lang="pug">
    el-popover(
        placement="top-start" width="460" :offset="50" trigger="click"
    )
        .couponBox
            .couponTitle
                .couponHalf(@click="type = 1")
                    div(:class="{'halfBox': type == 1}") 可用({{canOkcps.length}})
                .couponHalf(@click="type = 2")
                    div(:class="{'halfBox': type == 2}") 不可用({{cannotOkcps.length}})
                .line
            .couponDetail
                .none(v-if="coupons.length == 0") 暂无数据
                .coupon_de(
                    v-for="(item, i) in coupons" @click="toggleCp(i)"
                    :class="{'cur': curChooseCpIdx == i && type == 1, 'disable': type == 2 }"
                )
                    img.rightSoon(src="../../../assets/rightSoon@2x.png" v-if="type == 1 && item.almostExpired")
                    .coupon_de_left
                        .left_cot ￥
                            span {{item.amount}}
                        .left_satis.els(:title="item.couponName") {{item.couponName}}
                    .coupon_de_right
                        .right_title {{item.couponName}}
                        .right_time {{item.startTime | date(".") }} - {{item.endTime | date(".") }}
                        .right_reson(v-if="type == 2") {{item.reason || ''}}
        .fl(slot="reference" style="width: 200px;cursor: pointer;")
            .fl(style="margin-top: 2px;margin-right: 5px;") 使用优惠券
            .canUse.fl(style="cursor: pointer;")
                | {{canOkcps.length}}张可用
                i.el-icon-arrow-right

</template>

<script>
export default {
    name: 'CouponPoper',
    props: ['payPrice'],
    data () {
      return {
          type: 1,
          curChooseCpIdx: -1,
          chooseCoupon: 0,
          chooseCouponId: null
      }
    },
    computed: {
        okCps () { return this.storeGet('coupon/okCoupons') || [] },
        canOkcps () {
            if (!this.okCps || this.okCps.length == 0) return []
            let td = new Date().getTime()
            let data = this.okCps.filter(el => el.limit - 0 <= this.payPrice).filter(el => new Date(el.startTime).getTime() <= td && new Date(el.endTime).getTime() >= td)
            return data
        },
        cannotOkcps () {
            let td = new Date().getTime()
            return this.okCps.filter(el => {
                return el.limit - 0 > this.payPrice || new Date(el.startTime).getTime() > td || new Date(el.endTime).getTime() < td
            }).map(el => {
                if (!el.reason) el.reason = '该优惠券未满足使用价格'
                return el
            })
        },
        coupons () {
            return this.type == 1 ? this.canOkcps : this.cannotOkcps
        }
    },
    methods: {
        toggleCp (i) {
            if (this.type == 2) return
            if (this.curChooseCpIdx == i) this.curChooseCpIdx = -1
            else this.curChooseCpIdx = i
            if (this.curChooseCpIdx > -1) {
                let curCp = this.canOkcps[this.curChooseCpIdx]
                let amount = curCp.amount
                if (amount) {
                    this.chooseCoupon = amount - this.payPrice > 0 ? this.payPrice : amount
                    this.chooseCouponId = curCp.guid
                }
            } else {
                this.chooseCoupon = 0
                this.chooseCouponId = ''
            }
            // alert(this.chooseCoupon)
            this.$emit('cpChange', { data: this.chooseCoupon, id: this.chooseCouponId })
        }
    }
}
</script>


<style lang="sass" scoped>
.couponBox
    margin: -12px
    .couponTitle
        width: 458px
        height: 40px
        background-color: #F5F5F5
        border-bottom: 1px solid #D4D4D4
        position: relative
        .line
            position: absolute
            left: 229px
            top: 10px
            height: 20px
            width: 1px
            background: #E9E9E9
        .couponHalf
            float: left
            width: 50%
            cursor: pointer
            line-height: 39px
            text-align: center
            .halfBox
                margin: 0 auto
                width: 70px
                border-bottom: 1px solid #FF3973
                font-weight: bold
                color: #FF3973
    .couponDetail
        width: 100%
        height: 450px
        padding: 10px
        overflow: auto
        .none
            color: #999
            background: #F5F5F5
            height: 100px
            line-height: 100px
            text-align: center
        .coupon_de
            height: 100px
            border: 1px solid #F5F5F5
            border-radius: 4px
            position: relative
            margin-top: 10px
            cursor: pointer
            &.cur
                border: 2px solid #FF3973
            &.disable
                .coupon_de_left
                    .left_cot
                        color: #999
                .coupon_de_right
                    line-height: 25px
                    position: relative
                    top: -5px
                    .right_title
                        color: #999
            .rightSoon
                position: absolute
                top: 0
                right: 0
                width: 80px
                height: 30px
            .coupon_de_left
                float: left
                width: 120px
                text-align: center
                border-right: 1px solid #F5F5F5
                height: 60px
                margin-top: 20px
                .left_cot
                    font-size: 20px
                    color: #FF3973
                    font-weight: bold
                    line-height: 34px
                    span
                        font-size: 32px
                .left_satis
                    font-size: 14px
                    font-weight: 400
                    color: rgba(153, 153, 153, 1)
                    line-height: 20px
                    // margin-top: -5px
            .coupon_de_right
                float: left
                width: 300px
                padding-top: 17px
                padding-left: 20px
                line-height: 30px
                .right_title
                    font-size: 16px
                    font-weight: 600
                    color: rgba(40, 39, 41, 1)
                .right_time
                    font-size: 14px
                    font-weight: 400
                    color: rgba(153, 153, 153, 1)
                .right_reson
                    font-size: 14px
                    font-weight: 500
                    color: rgba(40, 39, 41, 1)
</style>
